import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useRef } from "react";
import { Portal } from "@magento/venia-ui/lib/components/Portal";
import UIkit from "uikit";
import Icon from "../Icon";
import defaultClasses from "./modal.module.scss";
import { mergeClasses } from "@magento/venia-ui/lib/classify";
const Modal = _ref => {
  let {
    classes: propClasses,
    id,
    dataTestId,
    nameClass,
    closeButtonClass,
    closeButtonColor = "white",
    closeButtonIcon = "icon-close",
    modalHeigthClass,
    modalFullScreen,
    modalCloseOutside,
    position = "vertical",
    canBeClosed = true,
    closeButton = true,
    modalDialogClass,
    modalDialogStyle,
    onClose,
    classNameExtra,
    isOpen = false,
    isXlarge,
    animation,
    children,
    customZIndex,
    centeredModal = true,
    backgroundColor = null
  } = _ref;
  const modalRef = useRef(null);
  const elementRef = useRef(null);
  const setBackgroundCloserHandler = () => {
    const handler = e => {
      // Check if the click target is inside the modal-content
      const isClickInsideModal = !!e.target.closest(".uk-modal-dialog");
      // Close the modal if the click is outside the modal content
      if (!isClickInsideModal && onClose && !modalCloseOutside) {
        onClose(e);
      }
    };
    const element = document.getElementById(id);
    // Add click event listener to the modal element
    element.addEventListener("click", handler);

    // Return a cleanup function to remove the event listener
    return () => {
      element.removeEventListener("click", handler);
    };
  };
  useEffect(() => {
    if (elementRef.current) {
      modalRef.current = UIkit.modal(elementRef.current);
      modalRef.current.container = document.getElementById("root");
      if (isOpen) {
        modalRef.current.show();
      } else {
        modalRef.current.hide();
      }
      let cleanupFunction;
      if (canBeClosed) {
        cleanupFunction = setBackgroundCloserHandler();
      }

      // Cleanup function for useEffect
      return () => {
        // This will be called when the component unmounts
        // or when isOpen or canBeClosed changes
        if (cleanupFunction) {
          cleanupFunction();
        }
      };
    }
  }, [isOpen, canBeClosed]);
  const classes = mergeClasses(defaultClasses, propClasses);
  const modalClass = classes[nameClass] ? classes[nameClass] : "";
  const style = _objectSpread(_objectSpread({}, customZIndex && {
    zIndex: customZIndex
  }), backgroundColor && {
    backgroundColor: backgroundColor
  });
  return /*#__PURE__*/React.createElement(Portal, {
    container: document.getElementById("root")
  }, /*#__PURE__*/React.createElement("div", _extends({
    id: id,
    ref: elementRef
  }, dataTestId && {
    "data-testid": dataTestId
  }, {
    className: "component-modal ".concat(modalFullScreen ? "uk-modal-full" : "", " ").concat(classNameExtra ? classNameExtra : "", " ").concat(modalClass, " ").concat(classes.root ? classes.root : ""),
    "data-uk-modal": "bg-close: false; container: false; stack: true",
    style: style
  }), /*#__PURE__*/React.createElement("div", {
    className: "uk-modal-dialog uk-flex uk-flex-column \n                    ".concat(modalDialogClass ? modalDialogClass : "", "\n                    ").concat(centeredModal ? "uk-flex-center " : "", "\n                    ").concat(defaultClasses.Width, " ").concat(modalHeigthClass ? modalHeigthClass : "", " \n                    ").concat(position ? position : "", "\n                    ").concat(animation ? animation : "uk-animation-slide-bottom", "\n                    "),
    style: modalDialogStyle,
    "uk-height-viewport": isXlarge ? "offset-bottom: 20; offset-top: 20" : null
  }, canBeClosed && closeButton ? /*#__PURE__*/React.createElement("button", {
    className: "uk-modal-close uk-margin-auto ".concat(closeButtonClass || "", " ").concat(modalFullScreen ? "uk-modal-close-full" : "", "  ").concat(modalCloseOutside ? "uk-modal-close-outside" : ""),
    type: "button",
    onClick: onClose,
    style: {
      width: "-webkit-min-content"
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: closeButtonIcon,
    color: closeButtonColor,
    header: true
  })) : null, children)));
};
export default Modal;